/* tslint:disable */
/* eslint-disable */
export enum UtilityOption {
    Required = 'REQUIRED',
    NotRequired = 'NOT_REQUIRED'
}
